function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import PhotoIcon from '@domain-group/fe-co-icon/lib/js/photo';
import ThreeDimensionalIcon from '@domain-group/fe-co-icon/lib/js/three-dimensional';
import VideoIcon from '@domain-group/fe-co-icon/lib/js/video';
import FloorPlanIcon from '@domain-group/fe-co-icon/lib/js/floor-plan';
import { MultiResolutionResponsiveImage } from '@domain-group/fe-co-multi-resolution-image';
import HeroCarousel from '../allhomes-hero-carousel';
import Placeholder from './allhomes-listing-photo-placeholder';
import navigationDecorators from './navigation-decorators';
import Map from './allhomes-listing-photo-map';
import * as styles from './allhomes-listing-hero-photo-preview.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var outerClass = 'fe-co-allhomes-hero-photo-preview';

// 2 pixel spacing between images
var CAROUSEL_IMAGE_MARGIN = 2;
function generateOnClickHandler(handler) {
  return handler ? {
    onClick: handler
  } : {};
}
function makeInnerImageFromProps(image, extraProps, single) {
  return ___EmotionJSX(MultiResolutionResponsiveImage, _extends({
    css: styles.hero({
      isSingle: single
    }),
    images: _objectSpread({
      srcSmall: image.srcSmall,
      srcMedium: image.srcMedium,
      srcLarge: image.srcLarge,
      srcExtraLarge: image.srcExtraLarge
    }, image.srcLowResolution ? {
      srcLowResolution: image.srcLowResolution
    } : {}),
    alt: image.title ? image.title : ''
  }, extraProps));
}
function makeInnerPlaceholderImage() {
  return ___EmotionJSX("div", {
    css: styles.hero({
      isPlaceholder: true
    })
  }, ___EmotionJSX(Placeholder, null));
}
function makeImageFromProps(image, index, content, single) {
  return ___EmotionJSX("button", {
    css: styles.heroContainer({
      isLink: image.onClick,
      isSingle: single
    }),
    type: "button",
    key: index,
    onClick: () => {
      if (image.onClick) {
        image.onClick();
      }
      if (image.galleryUrl) {
        window.location = image.galleryUrl;
      }
    },
    onDragStartCapture: event => {
      event.preventDefault();
    }
  }, content);
}
var AllhomesListingHeroPhotoPreview = _ref => {
  var media = _ref.media,
    images = _ref.images,
    address = _ref.address,
    onImageChanged = _ref.onImageChanged,
    staticMapUrl = _ref.staticMapUrl,
    isOffMarket = _ref.isOffMarket,
    floorPlanUrl = _ref.floorPlanUrl,
    galleryUrl = _ref.galleryUrl,
    virtualTourUrl = _ref.virtualTourUrl,
    videoUrl = _ref.videoUrl,
    onClickFloorPlan = _ref.onClickFloorPlan,
    onClickVirtualTour = _ref.onClickVirtualTour,
    onClickVideo = _ref.onClickVideo,
    onImageDisplayed = _ref.onImageDisplayed,
    onScrolledLeft = _ref.onScrolledLeft,
    onScrolledRight = _ref.onScrolledRight,
    onClickGallery = _ref.onClickGallery,
    onNavigationArrowClicked = _ref.onNavigationArrowClicked;
  var carouselCurrentIndex = useRef(0);
  var shownImages = useRef({});
  var mobile = media.mobile,
    tablet = media.tablet,
    desktop = media.desktop,
    desktopExtraWide = media.desktopExtraWide;
  var imagesToDisplay = desktop ? Math.min(images.length, desktopExtraWide ? 3 : 2) : 1;
  var handleNewlyDisplayedImages = useCallback(function (newIndex) {
    var newWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : imagesToDisplay;
    var previousImages = shownImages.current;
    var newImages = {};

    // Compare each image on the carousel to see whether it was already displayed
    for (var imageNum = newIndex; imageNum < newIndex + newWidth; imageNum += 1) {
      var realIndex = imageNum % images.length;
      newImages[realIndex] = true;
      if (!previousImages[realIndex]) {
        onImageDisplayed(realIndex);
      }
    }
    // Update the shown images map
    shownImages.current = newImages;
  }, [images.length, imagesToDisplay, onImageDisplayed]);
  useEffect(() => {
    if (images.length > 0) {
      handleNewlyDisplayedImages(carouselCurrentIndex.current);
    }
  }, [handleNewlyDisplayedImages, images.length]);
  useEffect(() => {
    var selector = document.querySelector(".".concat(outerClass));
    if (selector && selector.addEventListener) {
      var noop = () => {};
      var preventDefault = event => event.preventDefault();
      selector.addEventListener('touchmove', preventDefault, {
        passive: false
      });
      // preventDefault won't cancel on iOS 10 so we add this hack.
      // See https://git.io/folJ0
      selector.addEventListener('touchmove', noop);
      return () => {
        selector.removeEventListener('touchmove', noop);
        selector.removeEventListener('touchmove', preventDefault);
      };
    }
    return undefined;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var callScrollDirectionEventHandler = index => {
    var total = images.length;
    var rightMagnitude = (index + total - carouselCurrentIndex.current) % total;
    var leftMagnitude = (carouselCurrentIndex.current + total - index) % total;
    if (leftMagnitude < rightMagnitude) {
      onScrolledLeft(index);
    } else {
      onScrolledRight(index);
    }
  };
  var carouselMoved = index => {
    if (index !== carouselCurrentIndex.current) {
      callScrollDirectionEventHandler(index);
      onImageChanged(carouselCurrentIndex.current, index);
      handleNewlyDisplayedImages(index);
      carouselCurrentIndex.current = index;
    }
  };
  var makeFirstImage = firstImage => {
    if (isOffMarket && staticMapUrl) {
      return ___EmotionJSX("div", {
        css: styles.hero({
          isPlaceholder: true
        })
      }, ___EmotionJSX(Map, {
        staticMapUrl: staticMapUrl
      }));
    }
    return firstImage;
  };
  var imagesPresent = images.length !== 0;
  var multipleImagesPresent = images && images.length > 1;
  var galleryEnabled = (galleryUrl || onClickGallery) && images.length > 0;
  var virtualTourEnabled = virtualTourUrl || onClickVirtualTour;
  var videoEnabled = videoUrl || onClickVideo;
  var floorPlanEnabled = floorPlanUrl || onClickFloorPlan;
  var showGalleryIcons = (galleryEnabled || virtualTourEnabled || videoEnabled || floorPlanEnabled) && !mobile;
  var showMobileIcons = floorPlanEnabled && mobile;
  var carouselImages = images.map((image, index) => makeImageFromProps(image, index, makeInnerImageFromProps(image), false));

  // Buttons need separators if there's another button to their right.
  var showGalleryShortcutButtonSeparator = virtualTourEnabled || videoEnabled || floorPlanEnabled;
  var showVirtualTourShortcutButtonSeparator = videoEnabled || floorPlanEnabled;
  var showVideoShortcutButtonSeparator = floorPlanEnabled;
  var firstImage = imagesPresent ? makeImageFromProps(images[0], 0, makeInnerImageFromProps(images[0]), !multipleImagesPresent) : makeInnerPlaceholderImage();
  return ___EmotionJSX("section", {
    "aria-roledescription": "carousel",
    "aria-label": "Photo carousel".concat(address ? " for ".concat(address) : ''),
    id: "hero-carousel",
    css: styles.preview
  }, (mobile || tablet) && (multipleImagesPresent ? ___EmotionJSX(HeroCarousel, {
    firstImageStatic: true,
    infinite: true,
    onImageChanged: (oldIndex, newIndex) => carouselMoved(newIndex),
    showCounter: mobile
  }, carouselImages) : makeFirstImage(firstImage)), desktop && (multipleImagesPresent ? ___EmotionJSX(HeroCarousel, {
    onImageChanged: (oldIndex, newIndex) => carouselMoved(newIndex),
    showCounter: false,
    infinite: true,
    imagesToDisplay: imagesToDisplay,
    imagePadding: CAROUSEL_IMAGE_MARGIN,
    lazyLoadPadding: Math.max(imagesToDisplay - 1, 1),
    decorators: navigationDecorators({
      onNavigationArrowClicked
    })
  }, carouselImages) : makeFirstImage(firstImage)), (showGalleryIcons || showMobileIcons) && ___EmotionJSX("div", {
    css: styles.buttonAlignmentContainer
  }, ___EmotionJSX("div", {
    css: styles.buttonContainer
  }, galleryEnabled && ___EmotionJSX("a", _extends({
    css: styles.buttonLink,
    href: galleryUrl,
    title: "Photo Gallery"
  }, generateOnClickHandler(onClickGallery)), ___EmotionJSX("div", {
    css: styles.shortcutButton({
      withSeparator: showGalleryShortcutButtonSeparator
    })
  }, ___EmotionJSX(PhotoIcon, {
    size: "custom"
  }), ___EmotionJSX("div", {
    css: styles.photoTotal
  }, ___EmotionJSX("span", {
    css: styles.photoTotalText
  }, images.length)))), virtualTourEnabled && ___EmotionJSX("a", _extends({
    css: styles.buttonLink,
    href: virtualTourUrl,
    title: "3D Virtual Tour"
  }, generateOnClickHandler(onClickVirtualTour)), ___EmotionJSX("div", {
    css: styles.shortcutButton({
      withSeparator: showVirtualTourShortcutButtonSeparator
    })
  }, ___EmotionJSX(ThreeDimensionalIcon, {
    size: "custom"
  }))), videoEnabled && ___EmotionJSX("a", _extends({
    css: styles.buttonLink,
    href: videoUrl,
    title: "Video"
  }, generateOnClickHandler(onClickVideo)), ___EmotionJSX("div", {
    css: styles.shortcutButton({
      withSeparator: showVideoShortcutButtonSeparator
    })
  }, ___EmotionJSX(VideoIcon, {
    size: "custom"
  }))), floorPlanEnabled && ___EmotionJSX("a", _extends({
    css: styles.buttonLink,
    href: floorPlanUrl,
    title: "Floor Plan"
  }, generateOnClickHandler(onClickFloorPlan)), ___EmotionJSX("div", {
    css: styles.floorPlanButton
  }, ___EmotionJSX(FloorPlanIcon, {
    size: "custom"
  }), ___EmotionJSX("span", null, "Floorplan"))))));
};
AllhomesListingHeroPhotoPreview.propTypes = {
  galleryUrl: PropTypes.string,
  virtualTourUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  floorPlanUrl: PropTypes.string,
  onClickGallery: PropTypes.func,
  onClickVirtualTour: PropTypes.func,
  onClickVideo: PropTypes.func,
  onClickFloorPlan: PropTypes.func,
  onImageChanged: PropTypes.func,
  onImageDisplayed: PropTypes.func,
  onNavigationArrowClicked: PropTypes.func,
  onScrolledLeft: PropTypes.func,
  onScrolledRight: PropTypes.func,
  images: PropTypes.arrayOf(PropTypes.shape({
    srcSmall: PropTypes.string,
    srcLarge: PropTypes.string,
    srcMedium: PropTypes.string,
    srcExtraLarge: PropTypes.string,
    srcLowResolution: PropTypes.string,
    title: PropTypes.string,
    galleryUrl: PropTypes.string,
    onClick: PropTypes.func
  })).isRequired,
  address: PropTypes.string,
  staticMapUrl: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    desktop: PropTypes.bool,
    desktopExtraWide: PropTypes.bool
  }),
  isOffMarket: PropTypes.bool
};
AllhomesListingHeroPhotoPreview.defaultProps = {
  address: null,
  virtualTourUrl: null,
  videoUrl: null,
  floorPlanUrl: null,
  galleryUrl: null,
  onClickGallery: null,
  onClickVirtualTour: null,
  onClickVideo: null,
  onClickFloorPlan: null,
  onNavigationArrowClicked: () => {},
  onImageChanged: () => {},
  onScrolledLeft: () => {},
  onScrolledRight: () => {},
  onImageDisplayed: () => {},
  staticMapUrl: null,
  media: {
    mobile: true
  },
  isOffMarket: false
};
export default withMedia(AllhomesListingHeroPhotoPreview);
export { AllhomesListingHeroPhotoPreview as BaseAllhomesListingHeroPhotoPreview };